import { Box, Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GameCover from '../tavern/GameCover';
import { compactGameMetaLine, gameTitle } from './gameFormat';
import { localizedPrimaryTags } from './bggLocalization';

const GameCard = ({ game, ownerName, onClick }) => {
  const { i18n, t } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language;

  return (
    <Stack
      component="button"
      type="button"
      spacing={1}
      onClick={() => onClick?.(game)}
      sx={{
        p: 0,
        border: 0,
        textAlign: 'left',
        bgcolor: 'transparent',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover .game-cover': {
          transform: onClick ? 'translateY(-4px)' : 'none',
        },
      }}
    >
      <GameCover
        game={game}
        className="game-cover"
        sx={{
          width: '100%',
          transition: 'transform 160ms ease',
        }}
      />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h4" noWrap>
          {gameTitle(game, t, language)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {compactGameMetaLine(game, t)}
        </Typography>
        {ownerName ? (
          <Typography variant="body2" color="secondary.dark" fontWeight={700}>
            {t('games.card.onShelf', {
              owner: ownerName,
            })}
          </Typography>
        ) : null}
        <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap sx={{ mt: 0.75 }}>
          {localizedPrimaryTags(game, language, 2).map((tag) => (
            <Chip key={tag} label={tag} size="small" variant="outlined" />
          ))}
        </Stack>
      </Box>
    </Stack>
  );
};

export default GameCard;
